import React from 'react';
import './special-cells.scss';
import { Tooltip } from 'antd';
import { Column } from 'src/model/table';
import { ActionCell } from 'src/components/shared/action-cell/action-cell';

export const TooltipCell = <T,>(column: Column<T>, row: T, anotherClassname = '') =>
        <Tooltip title={row[column.accessor] as string} placement={'bottomLeft'} overlayClassName={`tooltip-cell ${anotherClassname}`}>
            <div data-testid={column.accessor}>{row[column.accessor] as any}</div>
        </Tooltip>;

export const IpWithTooltipCell = (column: Column<any>, row: any) => TooltipCell(column, row, 'complete-ip-tooltip');

export const ActionCellTrafficLog = <T extends { Action: any },>(column: Column<T>, row: T) => <ActionCell action={row.Action} />;